export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const ABREV_WEEKDAY = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const TAGGINGLABELS = ['today', 'tomorrow'];
const LOCALE = 'en-US';

export const parseDate = (dateString) => {
  let modifiedDateString = dateString;
  if (dateString) {
    modifiedDateString = new Date(`${dateString.split('-').join('/')}`);
  }
  const date = new Date(modifiedDateString);
  return {
    day: date.getDate(),
    month: MONTHS[date.getMonth()],
    year: date.getFullYear(),
  };
};

export const getTimeDifferenceFromToday = (fromDateLong) => {
  const counter = typeof window.duration !== 'undefined' ? window.duration : 0;
  const givenDateInMs = fromDateLong; // given date in milliseconds
  const todayInMs = new Date().getTime(); // today in milliseconds
  const msDiff = typeof window.duration !== 'undefined' ? counter : givenDateInMs - todayInMs;
  return msDiff;
};

export const startAndEndDate = (start, end) => {
  let newString = '';
  if (start && end) {
    let day = start.split(' ')[0];
    const dateStr = start.split(' ')[1];
    const startTime = start.split(' ')[2];
    const endTime = end.split(' ')[0];
    day = day
      ?.toLowerCase()
      .replace('mon', 'Monday')
      .replace('tue', 'Tuesday')
      .replace('wed', 'Wednesday')
      .replace('thu', 'Thursday')
      .replace('fri', 'Friday')
      .replace('sat', 'Saturday')
      .replace('sun', 'Sunday');
    newString = `${day}, ${Number(dateStr?.split('/')[0])}/${Number(dateStr?.split('/')[1])} ${Number(startTime?.split(':')[0])}${
      Number(startTime?.split(':')[1]) ? `:${startTime?.split(':')[1]}` : ''
    } ${start.split(' ')[3]} - ${Number(endTime?.split(':')[0])}${Number(endTime?.split(':')[1]) ? `:${endTime?.split(':')[1]}` : ''} ${
      end.split(' ')[1]
    }`;
  }
  return newString;
};

export const getBackOrderRangeText = (givenDate, isDeliverBy = false) => {
  let date = givenDate;
  if (givenDate) {
    date = new Date(`${givenDate.split('-').join('/')}`);
  }
  let finalString = '';
  if (date) {
    const endDate = `${ABREV_WEEKDAY[date.getDay()]}, ${MONTHS[date.getMonth()]} ${date.getDate()}`;
    let differenceDate = new Date(date.setDate(date.getDate() - (window?.vzFlags?.backOrderDifference || 0)));
    const today = new Date();
    if (today > differenceDate) {
      differenceDate = new Date(today.setDate(today.getDate() + 1));
    }
    const startDate = `${ABREV_WEEKDAY[differenceDate.getDay()]}, ${MONTHS[differenceDate.getMonth()]} ${differenceDate.getDate()}`;
    finalString =
      window?.vzFlags?.backOrderRanageText
        ?.replace('$DELIVERY_TYPE$', isDeliverBy ? 'Delivers' : 'Ships')
        ?.replace('$START_DATE$', startDate)
        ?.replace('$END_DATE$', endDate) || '';
  }
  return finalString;
};

export const getDay = (val, str) => {
  let day;
  if (val && str) {
    day = val.toDateString();
  } else {
    day = val;
  }
  return day.split(' ')[0];
};

export const getDeliveryDay = (selectedId, sddOption) => {
  const date = new Date().toLocaleString(LOCALE, { timeZone: sddOption?.sddAvailableWindows[0].timeZone });
  const TodaysDate = new Date(date);
  let NextDate = new Date(TodaysDate);
  NextDate = new Date(NextDate.setDate(TodaysDate.getDate() + 1));
  const sddWindow = sddOption?.sddAvailableWindows?.find((item) => item?.id === selectedId) || {};
  const selectedDay = getDay(sddWindow.startTime);
  const [today, tomorrow] = TAGGINGLABELS;
  let taggingLabel = '';

  if (getDay(TodaysDate, 'y').indexOf(selectedDay) > -1) {
    taggingLabel = today;
  } else if (getDay(NextDate, 'y').indexOf(selectedDay) > -1) {
    taggingLabel = tomorrow;
  }
  return `SDD_required_${taggingLabel}`;
};

export const getCurrentFormattedDate = () => {
  const currDate = new Date();
  return `${currDate.getMonth() + 1}/${currDate.getDate()}/${currDate.getFullYear()}`;
};
